import React from 'react'
import Activity from '../Components/Activity/Activity';
import "./log.scss";
const Log = () => {
  return (
    <div className="wcs_log">
      <div className="wcs_logContainer">
        <div className="dashboard_active" id='wcs_dashboard'>
          <div className="wcs_dashboard_cls">

            <div className="wpnts_visitor_traffic">
              <Activity />
            </div>

          </div>
        </div>
      </div>
    </div>
  )
}

export default Log
